import React, { useEffect, useState, useCallback } from "react";
import counter from "./counters.module.css";
import { useData } from "../../dentistContext/DentistConferenceContext";

const DisplayCounters = ({ storedData }) => {
  const { state } = useData();
  const data = state.data;
  const [counters, setCounters] = useState(() => {
    if (data && data.length > 1) {
      return {
        date1: data.reduce((partialSum, a) => partialSum + a.date1, 0),
        date2: data.reduce((partialSum, a) => partialSum + a.date2, 0),
        date3: data.reduce((partialSum, a) => partialSum + a.date3, 0),
        date4: data.reduce((partialSum, a) => partialSum + a.date4, 0),
        date5: data.reduce((partialSum, a) => partialSum + a.date5, 0),
        date6: data.reduce((partialSum, a) => partialSum + a.date6, 0),
      };
    } else return [];
  });

  const getTotals = useCallback(() => {
    if (data && data.length > 0) {
      counters.date1 = data.reduce((partialSum, a) => partialSum + a.date1, 0);
      counters.date2 = data.reduce((partialSum, a) => partialSum + a.date2, 0);
      counters.date3 = data.reduce((partialSum, a) => partialSum + a.date3, 0);
      counters.date4 = data.reduce((partialSum, a) => partialSum + a.date4, 0);
      counters.date5 = data.reduce((partialSum, a) => partialSum + a.date5, 0);
      counters.date6 = data.reduce((partialSum, a) => partialSum + a.date6, 0);
      setCounters(() => counters);
    }
  }, [data, counters]);

  useEffect(() => {
    if (data) getTotals();
  }, [getTotals, data]);

  return (
    <div className={counter.countercontainer}>
      <div className={counter.f1}>
        <span className={counter.label}>سبت </span>
        <span className={counter.value}>{counters.date1}</span>
        <span className={counter.label}>أحد </span>
        <span className={counter.value}>{counters.date2}</span>
        <span className={counter.label}>إثنين </span>
        <span className={counter.value}>{counters.date3}</span>
      </div>
      <div className={counter.f2}>
        <span className={counter.label}>ثلاثاء </span>
        <span className={counter.value}>{counters.date4}</span>
        <span className={counter.label}>أربعاء</span>
        <span className={counter.value}>{counters.date5}</span>
        <span className={counter.label}>خميس </span>
        <span className={counter.value}>{counters.date6}</span>
      </div>
    </div>
  );
};
export default DisplayCounters;
